import {InjectionToken} from "@angular/core";
import type {TransitionService} from "@uirouter/angularjs";

/** Definerer metoder fra ajs @uirouter {@link TransitionService} som vi benytter i ng2-koden */
export interface AjsTransitionService extends Pick<TransitionService, 'onSuccess'> {
}

export const ajs_$transitions_DI_TOKEN = new InjectionToken<AjsTransitionService>('ajs $transitions');
